import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const About = () => {
  useSEO({
    title: 'About Us | NYC SEO Agency',
    description: 'Learn about NewYorkCitySEO.agency, the leading team of technical SEO and AI search optimization experts dedicated to Manhattan, Brooklyn, and all NYC boroughs.',
  });

  return (
    <div className="pt-20 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Who We Are"
            title="Architects of Digital Dominance in New York City"
            description="We are a specialized collective of technical SEO engineers, content strategists, and AI optimization experts operating out of the heart of NYC."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 gap-16 mt-16 items-center">
          <AnimatedSection delay={0.2}>
            <div className="prose prose-invert prose-lg text-slate-300">
              <p>
                Founded on the principle that search is evolving faster than traditional marketing agencies can adapt, <strong>NewYorkCitySEO.agency</strong> was built specifically for the future of AI-powered search and the highly competitive New York City markets.
              </p>
              <p>
                Our mission is simple: To ensure our clients are the absolute most visible, authoritative, and trusted entities in their respective industries across Manhattan, Brooklyn, Queens, The Bronx, and Staten Island. 
              </p>
              <p>
                We do not rely on outdated tactics. We specialize in helping NYC businesses improve both traditional Google search visibility and AI discoverability through advanced technical SEO, high-authority content architecture, and Generative Engine Optimization (GEO) strategies. When users ask ChatGPT, Claude, or Google for the best service in NYC, our clients are the answer.
              </p>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.4}>
            <div className="glass-panel p-10 rounded-2xl border-blue-500/30 border shadow-2xl">
              <h3 className="text-2xl font-bold text-white mb-6">The NYC Advantage</h3>
              <ul className="space-y-4 text-slate-300">
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 text-xl">✓</span>
                  <span><strong>Hyper-Local Expertise:</strong> Deep understanding of NYC neighborhood search intent.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 text-xl">✓</span>
                  <span><strong>AI-First Approach:</strong> Pioneers in Generative Engine Optimization (GEO).</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 text-xl">✓</span>
                  <span><strong>Data-Driven:</strong> Decisions backed by advanced analytics and entity mapping.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 text-xl">✓</span>
                  <span><strong>Transparent Reporting:</strong> Clear metrics on traffic, ranking, and revenue growth.</span>
                </li>
              </ul>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </div>
  );
};

export default About;